import { useSelector } from 'react-redux';
import { ClientTypes, CLIENT_TYPES_ID } from '~/constants/clientTypes.ts';
import { useMemo } from 'react';
import { selectContragentType } from '~/store/identification-form/selectors';

export const useGetContragentTypes = () => {
  const contragentType = useSelector(selectContragentType);

  const isLegalResident = useMemo(
    () => contragentType?.value === CLIENT_TYPES_ID[ClientTypes.LEGAL_RESIDENT],
    [contragentType]
  ); // ЮОР

  const isSoleTrader = useMemo(
    () => contragentType?.value === CLIENT_TYPES_ID[ClientTypes.SOLE_TRADER],
    [contragentType]
  ); // ФОП

  return { isLegalResident, isSoleTrader, contragentType };
};

export default useGetContragentTypes;
